// timer para expand/collapse del banner
export const autoExpandInterval = 80000;
export const autoExpandDuration = 5000;
export const pollInterval = 200000;

// timer para el scroll del contenido
export const MENU_DURATION = 2000;
export const SCROLL_SPEED = 200;

// Retraso inicial (ms) antes de empezar a mostrar los banners animados
// ("expandir izquierda" / "expandir arriba"). Durante este tiempo solo se ve el
// banner fijo. Ejemplo: 3 minutos = 3 * 60 * 1000.
export const ANIMATED_BANNERS_START_DELAY = 1 * 60 * 1000;

// Incluye la clasificación después de la liga y antes de resultados/upcoming.
export const SHOW_STANDINGS = true;

// Momentáneo: excluye el bloque de noticias (key `news`) del ticker.
export const SHOW_NEWS = true;

// Controla si se muestra el bloque de próximos partidos (key `upcoming`) en el ticker.
export const SHOW_UPCOMING = true;

// Controla si se muestra el bloque de resultados (key `results`) en el ticker.
export const SHOW_RESULTS = true;

// Controla si BASE (MLB) y AMFO (NFL) muestran SIEMPRE ambos bloques
// (results + upcoming) o si respetan la validación estándar de FOOT (alternan
// results/upcoming según la ventana de 24h del primer upcoming).
// - `true`:  BASE y AMFO muestran siempre ambos bloques.
// - `false`: BASE y AMFO aplican la validación de 24h de FOOT.
export const SHOW_BOTH_BLOCKS = false;

// timer para rotacion de los goleadores
export const GOAL_ROTATION_INTERVAL = 3000;

// timer para carrousel de resultados
export const FOOT_RESULT_DURATION = 8000;

// timer para carrousel vertical de noticias: cada noticia permanece este tiempo
export const NEWS_ROTATION_INTERVAL = 10000;


// confirmacion de fecha para los standings
export const formatDate = (value) => {
  if (!value) return "Fecha por confirmar";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Fecha por confirmar";

  const month = date.toLocaleDateString("es-MX", { month: "short" }).replace(".", "").toUpperCase();
  const day = date.getDate();
  const time = date.toLocaleTimeString("es-MX", { hour: "2-digit", minute: "2-digit", hour12: false });
  return `${month} ${day} | ${time}`;
};

// valida el campo goleado y tiempo del gol
export const getGoalKey = (goal) => [
  goal?.scorerId ?? goal?.scorer_id ?? goal?.scorerName ?? goal?.scoreName ?? "goal",
  goal?.timeMin ?? goal?.time_min ?? "minute",
].join("-");